export enum CFC_ROLE {
  ADMIN = "admin",
  USER = "user",
  EMISSION_FACTOR_ADMIN = "cfc.emission-factor.admin",
}
